import MediaIconButton from "@pathwright/legacy-media-manager/src/MediaIconButton"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import useCopyToClipboard from "@pathwright/utils/src/clipboard/useCopyToClipboard"

const CopyLinkButton = ({ link }) => {
  const copyToClipboard = useCopyToClipboard()

  const handleCopy = (str) => () => {
    copyToClipboard(str, { description: null })
  }

  return (
    <Tooltip title="Copy link">
      <MediaIconButton
        style={{ marginRight: "10px" }}
        onClick={handleCopy(link)}
        icon="copy"
      />
    </Tooltip>
  )
}

export default CopyLinkButton
